import React from 'react';

const BasicReport: React.FC = () => (
    <p data-q="motors-vhc-badge-text" data-testid="basic-report-text">
        This vehicle has not been reported stolen, scrapped, exported or flagged as unroadworthy.
    </p>
);

export default BasicReport;
